import { defineMessages } from 'react-intl';

export default defineMessages({
    atFaultCategoryValidationMessage: {
        id: 'walrt.quote.incident.atFaultCategoryValidationMessage',
        defaultMessage: 'Please add and classify at-fault auto accidents as an "At-Fault Accident"'
    }
})